import React, { useState } from 'react';
import { connect } from "react-redux";
import { daysName, monthNames, daysNameEvaluation } from "../../../actions/utility"
import { submitEvaluationReport, submitDemoStudentFeedback } from "../../../actions/tutorFeedActions"
import "./Evaluations.css";

const DemoStudentEvaluation = (props) => {
    const { evaluationData, programId, teacherId, clientId } = props;
    const [firstSection, setfirstSection] = useState('');
    const [secondSection, setsecondSection] = useState('');
    const [thirdSection, setthirdSection] = useState('');
    const [fourthSectionArray, setfourthSectionArray] = useState([]);
    const [fifthSectionArray, setfifthSectionArray] = useState([]);
    const [arrayForSend, setarrayForSend] = useState([]);
    const [snackbarMessage, setsnackbarMessage] = useState("");
    const [snackbar, setsnackbar] = useState(false);
    const [snackColor, setsnackColor] = useState("");
    const [disbaleBtn, setdisbaleBtn] = useState(false);

    const changeOfFirsSection = (e, key) => {
        debugger;
        var data = {
            [key]: e.target.value,
            "whatsAppValue": e.target.name
        }
        // setarrayForSend(data , ...arrayForSend);
        setfirstSection({ [key]: e.target.value, "whatsappVal": e.target.name });
        console.log("Data", data);
        // console.log("Data to submit", firstSection);
    }
    const changeOfSecondSection = (e, key) => {
        var data = {
            [key]: e.target.value
        }
        // setarrayForSend(data , ...arrayForSend);
        setsecondSection({ [key]: e.target.value, "whatsappVal": e.target.name });
        console.log("Data", data);
        // console.log("Data to submit", arrayForSend);
    }
    const changeOfThirdSection = (e, key) => {
        var data = [{
            [key]: e.target.value
        }]
        // setarrayForSend([...arrayForSend, {...data}]);
        setthirdSection({ [key]: e.target.value, "whatsappVal": e.target.name });
        console.log("Data", data);
        // console.log("Data to submit", arrayForSend);
    }
    const changeOfFourthSection = (e, key) => {
        if (e.target.checked) {
            debugger;
            fourthSectionArray.push({
                id: key,
                data: e.target.value,
                whatsappVal: e.target.name
            })
        }
        else {
            var a = fourthSectionArray.filter(item => item.id !== key);
            setfourthSectionArray(a);
            debugger;
        }
    }
    const changeOfFifthSection = (e, key) => {
        if (e.target.checked) {
            debugger;
            fifthSectionArray.push({
                id: key,
                data: e.target.value,
                whatsappVal: e.target.name
            })
        }
        else {
            var a = fifthSectionArray.filter(item => item.id !== key);
            setfifthSectionArray(a);
            debugger;
        }
    }

    const submitDemoEvaluation = (stdId, courseId, studentName) => {
        setdisbaleBtn(true);
        var feedback_data =
        {
            // "firstSection": [
            //     firstSection
            // ],
            "secondSection": [
                secondSection
            ],
            "thirdSection": [
                thirdSection
            ],
            "fourthSection": {
                question: `The problems that we noticed were that ${studentName}`,
                fourthSectionArray,
            },
            "fifthSection": {
                question: `Going forward we will help ${studentName}`,
                fifthSectionArray
            }
        }
        // console.log("Data to submit", Data);
        props.submitDemoStudentFeedback(stdId, teacherId, courseId, programId, feedback_data)
            .then((res) => {
                if (res.status == "success") {
                    setdisbaleBtn(false);
                    setsnackbarMessage("Feedback Sent Successfully");
                    setsnackbar(true);
                    setsnackColor("#01ac8a")
                    setTimeout(() => {
                        setsnackbar(false);
                    }, 3000);
                }
                else {
                    setdisbaleBtn(false);
                    setsnackbarMessage(res.message);
                    setsnackbar(true);
                    setsnackColor("#ed2525")
                    setTimeout(() => {
                        setsnackbar(false);
                    }, 3000);
                }
                debugger;
            })
    }

    const fourthData = [
        {
            id: 1,
            data: "was late to class",
            whatsappVal: "*was late to class*",
        },
        {
            id: 2,
            data: "did not have a good Internet connection",
            whatsappVal: "*did not have a good Internet connection*",
        },
        {
            id: 3,
            data: "was in a noisy/distracted surrounding",
            whatsappVal: "*was in a noisy/distracted surrounding*",
        },
        {
            id: 4,
            data: "was confused because the parent was interfering",
            whatsappVal: "*was confused because the parent was interfering*",
        },
        {
            id: 5,
            data: "did not have tablet or a laptop which made learning difficult",
            whatsappVal: "*did not have tablet or a laptop which made learning difficult*",
        },
        {
            id: 6,
            data: "did not turn on the camera which made learning difficult",
            whatsappVal: "*did not turn on the camera which made learning difficult*",
        },
        {
            id: 7,
            data: "basic concepts of the topics were weak",
            whatsappVal: "*basic concepts of the topics were weak*",
        },
        {
            id: 8,
            data: "was hesitant to participate in the class",
            whatsappVal: "*was hesitant to participate in the class*",
        },
        {
            id: 9,
            data: "could do better if concepts were revised",
            whatsappVal: "*could do better if concepts were revised*",
        },
        {
            id: 10,
            data: "was not prepared for the online class",
            whatsappVal: "*was not prepared for the online class*",
        },
    ]
    const fifthData = [
        {
            id: 1,
            data: "learn ahead and be smarter than their peers",
            whatsappVal: "*learn ahead and be smarter than their peers*",
        },
        {
            id: 2,
            data: "do a lot of worksheets and quizzes",
            whatsappVal: "*do a lot of worksheets and quizzes*",
        },
        {
            id: 3,
            data: "revise and strengthen concepts",
            whatsappVal: "*revise and strengthen concepts*",
        },
        {
            id: 4,
            data: "help prepare for upcoming school exams",
            whatsappVal: "*help prepare for upcoming school exams*",
        },
        {
            id: 5,
            data: "help with school homework",
            whatsappVal: "*help with school homework*",
        },
        {
            id: 6,
            data: "provide extra help and attention during class",
            whatsappVal: "*provide extra help and attention during class*",
        },
        {
            id: 7,
            data: "present their work in class and be appreciated",
            whatsappVal: "*present their work in class and be appreciated*",
        },
    ]
    return (
        <div className="row">
            <div className="col-md-12" id="evaluationDiv">
                <div className={snackbar ? "show" : ""} id="snackbar" style={{ backgroundColor: snackColor }}>{snackbarMessage}</div>
                <h5 style={{ fontSize: 18 }}>Demo Student Feedback</h5>
                <div id="accordion3">
                    <div>
                        {evaluationData.map((item, index) =>
                            item.is_scheduled_demo === 1 &&
                            <div className="row">
                                <div className="col-md-12">
                                    <div data-toggle="collapse"
                                        data-target={`#open${index}`}
                                        className="collapsed collapseDemo"
                                    >
                                        {item.image !== null ? <img src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.image}`} alt="Avatar" className="avatarStudent" /> : <img src={require("../../../public/images/emptyuserphoto.png")} alt="Avatar" className="avatarStudent" />}
                                        <label className="avatarMargin">{item.name}  </label>
                                    </div>

                                    <div
                                        id={`open${index}`}
                                        className="collapse collapseDemoOpen"
                                        aria-labelledby="headingOne"
                                        data-parent="#accordion3"
                                    >
                                        {/* <div>
                                            <p>In the beginning of the class {item.name}</p>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name={`*was confident and excited.* So our goal would be to help *${item.name}* learn how to become the leader in any classroom setting`} value={`was confident and excited. So our goal would be to help ${item.name} learn how to become the leader in any classroom setting`} checked={firstSection[`In the beginning of the class ${item.name}`] === `was confident and excited. So our goal would be to help ${item.name} learn how to become the leader in any classroom setting`} onChange={(e) => changeOfFirsSection(e, `In the beginning of the class ${item.name}`)} />
                                                <label className="form-check-label text-muted" for="inlineRadio1">was confident and excited. So our goal would be to help {item.name} learn how to become the leader in any classroom setting</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name={`*was quite.* So our goal would be to help *${item.name}* learn how to quickly adjust to any new setting `} value={`was quite. So our goal would be to help ${item.name} learn how to quickly adjust to any new setting `} checked={firstSection[`In the beginning of the class ${item.name}`] === `was quite. So our goal would be to help ${item.name} learn how to quickly adjust to any new setting `} onChange={(e) => changeOfFirsSection(e, `In the beginning of the class ${item.name}`)} />
                                                <label className="form-check-label text-muted" for="inlineRadio1">was quite. So our goal would be to help {item.name} learn how to quickly adjust to any new setting </label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name={`*was a little reserved.* So our goal would be to help *${item.name}* to be comfortable whenever there is a new setting`} value={`was a little reserved. So our goal would be to help ${item.name} to be comfortable whenever there is a new setting`} checked={firstSection[`In the beginning of the class ${item.name}`] === `was a little reserved. So our goal would be to help ${item.name} to be comfortable whenever there is a new setting`} onChange={(e) => changeOfFirsSection(e, `In the beginning of the class ${item.name}`)} />
                                                <label className="form-check-label text-muted" for="inlineRadio1">was a little reserved. So our goal would be to help {item.name} to be comfortable whenever there is a new setting</label>
                                            </div>
                                        </div> */}

                                        <div className="mt-4">
                                            <p>{item.name} (select one)</p>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name={`*was very confident and was able to engage very quickly.* In our next class we can give *${item.name}* and opportunity to lead class discussions`} value={`was very confident and was able to engage very quickly. In our next class we can give ${item.name} and opportunity to lead class discussions`} checked={secondSection[`${item.name}`] === `was very confident and was able to engage very quickly. In our next class we can give ${item.name} and opportunity to lead class discussions`} onChange={(e) => changeOfSecondSection(e, `${item.name}`)} />
                                                <label className="form-check-label text-muted" for="inlineRadio1"><span className="text-success">was very confident and was able to engage very quickly.</span> In our next class we can give {item.name} and opportunity to lead class discussions</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name={`*was able to slowly integrate and engage with other in the class.* In our next class we will encourage *${item.name}* to participate more actively and open up a little more. This will increase ${item.name}'s confidence level`} value={`was able to slowly integrate and engage with other in the class. In our next class we will encourage ${item.name} to participate more actively and open up a little more. This will increase ${item.name}'s confidence level`} checked={secondSection[`${item.name}`] === `was able to slowly integrate and engage with other in the class. In our next class we will encourage ${item.name} to participate more actively and open up a little more. This will increase ${item.name}'s confidence level`} onChange={(e) => changeOfSecondSection(e, `${item.name}`)} />
                                                <label className="form-check-label text-muted" for="inlineRadio1"><span className="" style={{ color: "orange" }}>was able to slowly integrate and engage with other in the class.</span> In our next class we will encourage {item.name} to participate more actively and open up a little more. This will increase {item.name}'s confidence level</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name={`*was a little shy and quite and took time to open up.* In our next class we will use a rewards system to empower *${item.name}*, and help them engage more in class discussions`} value={`was a little shy and quite and took time to open up. In our next class we will use a rewards system to empower ${item.name}, and help them engage more in class discussions`} checked={secondSection[`${item.name}`] === `was a little shy and quite and took time to open up. In our next class we will use a rewards system to empower ${item.name}, and help them engage more in class discussions`} onChange={(e) => changeOfSecondSection(e, `${item.name}`)} />
                                                <label className="form-check-label text-muted" for="inlineRadio1"><span className="text-danger">was a little shy and quite and took time to open up.</span> In our next class we will use a rewards system to empower {item.name}, and help them engage more in class discussions</label>
                                            </div>
                                        </div>

                                        <div className="mt-4">
                                            <p>{item.name} (select one)</p>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name={`*had a strong understanding of what was being taught.* This means that we will be able to teach *${item.name}* at an advanced level so they are always ahead of everyone else`} value={`had a strong understanding of what was being taught. This means that we will be able to teach ${item.name} at an advanced level so they are always ahead of everyone else`} checked={thirdSection[`${item.name}`] === `had a strong understanding of what was being taught. This means that we will be able to teach ${item.name} at an advanced level so they are always ahead of everyone else`} onChange={(e) => changeOfThirdSection(e, `${item.name}`)} />
                                                <label className="form-check-label text-muted" for="inlineRadio1"><span className="text-success">had a strong understanding of what was being taught.</span> This means that we will be able to teach {item.name} at an advanced level so they are always ahead of everyone else</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name={`*started understanding the content that was being taught.* in class. This means that we want focus on solidifying *${item.name}'s* concepts by using lots of worksheets and quizzes`} value={`started understanding the content that was being taught in class. This means that we want focus on solidifying ${item.name}'s concepts by using lots of worksheets and quizzes`} checked={thirdSection[`${item.name}`] === `started understanding the content that was being taught in class. This means that we want focus on solidifying ${item.name}'s concepts by using lots of worksheets and quizzes`} onChange={(e) => changeOfThirdSection(e, `${item.name}`)} />
                                                <label className="form-check-label text-muted" for="inlineRadio1"><span style={{ color: "orange" }}>started understanding the content that was being taught in class. </span> This means that we want focus on solidifying {item.name}'s concepts by using lots of worksheets and quizzes</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name={`*was struggling to understand the content that was being taught.* This means that during every class we will give extra attention to each concept to make sure that *${item.name}* is able understand and comprehend.`} value={`was struggling to understand the content that was being taught. This means that during every class we will give extra attention to each concept to make sure that ${item.name} is able understand and comprehend.`} checked={thirdSection[`${item.name}`] === `was struggling to understand the content that was being taught. This means that during every class we will give extra attention to each concept to make sure that ${item.name} is able understand and comprehend.`} onChange={(e) => changeOfThirdSection(e, `${item.name}`)} />
                                                <label className="form-check-label text-muted" for="inlineRadio1"><span className="text-danger">was struggling to understand the content that was being taught.</span> This means that during every class we will give extra attention to each concept to make sure that {item.name} is able understand and comprehend. </label>
                                            </div>
                                        </div>

                                        <div className="mt-4">
                                            <p>The problems that we noticed were that {item.name} (select two or more)</p>
                                            {fourthData.map((data, indexs) =>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" name={data.whatsappVal} value={data.data} onChange={(e) => changeOfFourthSection(e, data.id)} />
                                                    <label className="form-check-label text-muted">{data.data}</label>
                                                </div>
                                            )}
                                        </div>

                                        <div className="mt-4">
                                            <p>Going forward we will help {item.name} (select two or more)</p>
                                            {fifthData.map((data, indexs) =>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" name={data.whatsappVal} value={data.data} onChange={(e) => changeOfFifthSection(e, data.id)} />
                                                    <label className="form-check-label text-muted">{data.data}</label>
                                                </div>
                                            )}
                                        </div>

                                        <div className="text-right">
                                            <button className="btn btn-sm btn-success" disabled={disbaleBtn} onClick={() => submitDemoEvaluation(item.id, item.course_id, item.name)}>Send {item.name}'s Feedback <i className="fas fa-paper-plane"></i> {disbaleBtn ?
                                                <div className="spinner-border ml-2 spinner-border-sm" role="status">
                                                    <span className="sr-only mt-2">Loading...</span>
                                                </div>
                                                :
                                                null
                                            }</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        programNameState: state.feedTutorRed.programName,
        attendanceData: state.feedTutorRed.attendanceData
    };
}
export default connect(mapStateToProps, { submitEvaluationReport, submitDemoStudentFeedback })(DemoStudentEvaluation);